/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { OrganizationSite } from '../../models/organization-site';

export interface ArchiveAdministrationOrganizationSite$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function archiveAdministrationOrganizationSite(http: HttpClient, rootUrl: string, params: ArchiveAdministrationOrganizationSite$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationSite>> {
  const rb = new RequestBuilder(rootUrl, archiveAdministrationOrganizationSite.PATH, 'delete');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationSite>;
    })
  );
}

archiveAdministrationOrganizationSite.PATH = '/administration/organization-sites/{organizationSiteKey}';
